import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { IoMdAnalytics } from "react-icons/io";
import "./online-classes.css";
import { useNavigate } from "react-router-dom";
const OnlineClasses = () => {
  const navigate = useNavigate();
  const handleDropdownChange = (e) => {
    if (e.target.value === "View") {
      navigate("/online-class/view");
    } else if (e.target.value === "Edit") {
      navigate("/online-class/create", {
        state: {
          type: "Edit",
        },
      });
    }
  };
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  const [TableData, setTableData] = React.useState([
    {
      courseTitle: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Willow Anderson",
      noOfStudents: 10,
      country: "burnside",
      state: "burnside",
      startDate: "JAN 4, 2022",
      startTime: "08:00 Am",
      status: "Active",
    },
    {
      courseTitle: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Henry O'Brien",
      noOfStudents: 10,
      country: "burnside",
      state: "burnside",
      startDate: "JAN 4, 2022",
      startTime: "08:00 Am",
      status: "Active",
    },
    {
      courseTitle: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Willow Anderson",
      noOfStudents: 20,
      country: "burnside",
      state: "burnside",
      startDate: "JAN 4, 2022",
      startTime: "08:00 Am",
      status: "Deactive",
    },
    {
      courseTitle: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Henry O'Brien",
      noOfStudents: 10,
      country: "burnside",
      state: "burnside",
      startDate: "JAN 4, 2022",
      startTime: "08:00 Am",
      status: "Active",
    },
    {
      courseTitle: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Willow Anderson",
      noOfStudents: 20,
      country: "burnside",
      state: "burnside",
      startDate: "JAN 4, 2022",
      startTime: "08:00 Am",
      status: "Deactive",
    },
    {
      courseTitle: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Henry O'Brien",
      noOfStudents: 10,
      country: "burnside",
      state: "burnside",
      startDate: "JAN 4, 2022",
      startTime: "08:00 Am",
      status: "Active",
    },
    {
      courseTitle: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Willow Anderson",
      noOfStudents: 20,
      country: "burnside",
      state: "burnside",
      startDate: "JAN 4, 2022",
      startTime: "08:00 Am",
      status: "Deactive",
    },
  ]);
  const handleStatusDropdownChange = (event, tableIndex) => {
    TableData[tableIndex].status = event.target.value;
    setTableData([...TableData]);
  };
  return (
    <SideMenu>
      <div className="page-container">
        <div className="page-header-button-main">
          <Button
            className="page-header-button"
            variant="text"
            onClick={() => {
              navigate("/online-class/create", {
                state: {
                  type: "Create",
                },
              });
            }}
          >
            <p className="page-header-button-text">create online class</p>
          </Button>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={7} xs={12}>
              <div>
                <p className="header-input-heading">Search by course Name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by course Name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
              <div>
                <p className="header-input-heading">Search by Tutor</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by tutor"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Country</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">State</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Status</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  <option value="Complated">Complated</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={4} sm={4} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
            <Grid item xl={7} lg={7} md={6} sm={6} xs={12}></Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">Online Class</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="online-classes-table-id-heading">ID</th>
                <th className="online-classes-table-image-heading">Image</th>
                <th className="online-classes-table-course-title-heading">
                  Course Title
                </th>
                <th className="online-classes-table-description-heading">
                  Discription
                </th>
                <th className="online-classes-table-tutors-name-heading">
                  Tutors Name
                </th>
                <th className="online-classes-table-students-no-heading">
                  No. of Students
                </th>
                <th className="online-classes-table-country-heading">
                  Country
                </th>
                <th className="online-classes-table-state-heading">State</th>
                <th className="online-classes-table-start-date-heading">
                  Start Date
                </th>
                <th className="online-classes-table-start-time-heading">
                  Start Time
                </th>
                <th className="online-classes-table-status-heading">Status</th>
                <th className="online-classes-table-action-heading"></th>
                <th className="online-classes-table-analytics-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex+1}</td>
                    <td className="table-data">
                      <img src={ProfileImg} className="table-image" />
                    </td>
                    <td className="table-data">{tableValue.courseTitle}</td>
                    <td className="table-data">{tableValue.description}</td>
                    <td className="table-data">{tableValue.tutorName}</td>
                    <td className="table-center-data">{tableValue.noOfStudents}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">{tableValue.state}</td>
                    <td className="table-data">{tableValue.startDate}</td>
                    <td className="table-data">{tableValue.startTime}</td>
                    <td className="table-data">
                      <select
                        className="table-status-dropdown"
                        style={{
                          backgroundColor:
                            tableValue.status === "Deactive"
                              ? "#FFB0B0"
                              : "#D2FFEB",
                          color:
                            tableValue.status === "Deactive"
                              ? "#B80000"
                              : "#098B51",
                        }}
                        onChange={(e) =>
                          handleStatusDropdownChange(e, tableIndex)
                        }
                      >
                        <option
                          value="Active"
                          selected={
                            tableValue.status === "Active" && "selected"
                          }
                        >
                          Active
                        </option>
                        <option
                          value="Deactive"
                          selected={
                            tableValue.status === "Deactive" && "selected"
                          }
                        >
                          Deactive
                        </option>
                      </select>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={handleDropdownChange}
                      >
                        <option value="">Action</option>
                        <option value="View">View</option>
                        <option value="Edit">Edit</option>
                        <option value="Delete">Delete</option>
                      </select>
                    </td>
                    <td className="table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => navigate("/online-class/analytics")}
                      >
                        <IoMdAnalytics color="#663399" size={20} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default OnlineClasses;
